import { useCookie } from "#app";
import { defineStore } from "pinia";

export const useSurveyWidgetStore = defineStore("surveyWidget", () => {
  const showWidget = ref(false);
  const config = useRuntimeConfig().public;

  const allowedPages = config.allowedPages?.length ? config.allowedPages.split(",") : [];

  const allowedLocales = config.allowedLocales?.length ? config.allowedLocales.split(",") : [];

  const feedbackFormPopupTime = config.feedbackFormPopupTime || 30; // Default to 30 seconds if not set

  const dismissedUntil = useCookie("survey_dismissed_until", { maxAge: 86400 }); //cookie expires in 1 day
  const completedSurvey = useCookie("survey_completed", {
    maxAge: 60 * 60 * 24 * 365 * 10,
  }); //remember forever

  const delayTimer = ref(null);
  const checkVisibility = (routePath, locale) => {
    // Reset first
    showWidget.value = false;

    // If user completed survey, never show again
    if (completedSurvey.value) return;

    // If user dismissed recently, don't show
    const now = new Date();
    if (dismissedUntil.value && new Date(dismissedUntil.value) > now) return;

    // Only allow on specified pages (with wildcard support)
    const pageMatch = allowedPages.some((page) => {
      if (page.endsWith("/*")) {
        const prefix = page.slice(0, -1); // Remove the '*' at the end
        return routePath.startsWith(prefix);
      }
      return routePath === page;
    });
    if (!pageMatch) return;

    // Only allow on specified locales
    if (!allowedLocales.includes(locale)) return;

    delayTimer.value = setTimeout(() => {
      showWidget.value = true;
    }, feedbackFormPopupTime * 1000); // Convert seconds to milliseconds
  };

  const dismissTemporarily = () => {
    const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000); //24 hours
    //const tomorrow = new Date(Date.now() + 20 * 1000); //20s for testing
    dismissedUntil.value = tomorrow.toISOString();
    showWidget.value = false;
    clearTimer();
  };

  const completeSurvey = () => {
    completedSurvey.value = "true";
    showWidget.value = false;
    clearTimer();
  };

  const clearTimer = () => {
    if (delayTimer.value) clearTimeout(delayTimer.value);
    delayTimer.value = null;
  };

  return {
    showWidget,
    checkVisibility,
    dismissTemporarily,
    completeSurvey,
  };
});
